import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Field, useFormikContext } from 'formik';
import { get, kebabCase } from 'lodash';
import { getInputClasses, getValidateFieldFunction, getValidationStatus } from './inputsUtils';
import { Radio } from './formik-input/Radio';
import { ErrorNote } from './formik-input/ErrorNote';
type Props = {
  className?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  name: string;
  options: ReadonlyArray<{
    label: string | Node;
    value: string;
    isDisabledRadio?: boolean;
  }>;
  validate?: () => boolean;
  hideErrorMessage?: boolean;
  radioHasBorder?: boolean;
  itemsCentered?: boolean;
};
export const RadioGroup = ({
  className,
  isDisabled = false,
  isRequired = false,
  name,
  options = [],
  validate,
  hideErrorMessage,
  radioHasBorder = true,
  itemsCentered = true,
}: Props) => {
  const formik = useFormikContext();
  return (
    <div className="sm:w-full" data-testid="RadioGroup">
      <div className={classnames('-mx-5 flex flex-wrap gap-y-5 sm:flex-nowrap', className)}>
        {options.map(({ label, value, isDisabledRadio = false }) => {
          const fieldIdentifier = `${name}-${value}`;
          return (
            <Field
              key={fieldIdentifier}
              name={name}
              type="radio"
              validate={validate ? getValidateFieldFunction(validate) : undefined}
              value={value}
            >
              {({ field, form }) => {
                const { isDefaultState, isErrored, isValidated } = getValidationStatus(
                  field,
                  form,
                  false,
                );
                const classes = getInputClasses({
                  hasHeight: true,
                  isDefaultState,
                  isDisabled,
                  isErrored,
                  isValidated: isValidated && field.checked,
                  hasNoBorder: !radioHasBorder,
                });
                return (
                  <Radio
                    className={classnames(
                      'sm:basis-0 mx-5 basis-[calc(50%-2.5rem)] font-bold sm:flex-1',
                      classes,
                    )}
                    field={field}
                    form={form}
                    isDisabled={isDisabled || isDisabledRadio}
                    isRequired={isRequired}
                    label={label}
                    size="size-20"
                    itemsCentered={itemsCentered}
                  />
                );
              }}
            </Field>
          );
        })}
      </div>
      <div className="px-10">
        {!hideErrorMessage && formik.submitCount > 0 && (
          <ErrorNote
            isErrored={formik.submitCount > 0}
            errorMessage={get(formik.errors, name)}
            errorNoteId={`error-${kebabCase(name)}`}
          />
        )}
      </div>
    </div>
  );
};
